import Security from "./security";

const setItem = (key, StringContent) => {
    localStorage.setItem(key, Security.encryptContent(StringContent))
}

const getItem = (key) => {
    return Security.decryptContent(localStorage.getItem(key))
}

const removeItem = (key) => {
    localStorage.removeItem(key)
}

//export {setUserProfile, getUserProfile}
export {setItem, getItem, removeItem}